<template>
    <g>
        <defs>
            <linearGradient id="um6baoquga" x1="50%" x2="50%" y1="163.811%" y2="1.562%">
                <stop offset="0%" :stop-color="colors.WHITE" stop-opacity="0"/>
                <stop offset="100%" stop-color="#EFEFF2"/>
            </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <g>
                <g>
                    <path fill="url(#um6baoquga)" d="M0 91.282h116.566c-15.165-14.278-35.693-23.049-58.282-23.049-22.591 0-43.118 8.771-58.284 23.05" transform="translate(-227 -124) translate(227 124)"/>
                    <g>
                        <path :fill="colorsV2.LIGHT_200" d="M24.509 81.158L67.066 81.158 67.066 33.099 24.509 33.099z" transform="translate(-227 -124) translate(227 124) translate(21.467 .111)"/>
                        <path :fill="colorsV2.LIGHT_300" d="M6.586 81.158L24.525 81.158 24.525 33.099 6.586 33.099z" transform="translate(-227 -124) translate(227 124) translate(21.467 .111)"/>
                        <path :fill="colorsV2.LIGHT_400" d="M24.525 33.126L6.586 33.126.263 24.268 18.202 24.268zM49.109 33.126L67.047 33.126 73.371 24.268 55.431 24.268zM49.204 74.273L60.2 74.273 60.2 71.973 49.204 71.973zM49.204 69.5L60.2 69.5 60.2 67.2 49.204 67.2z" transform="translate(-227 -124) translate(227 124) translate(21.467 .111)"/>
                        <path :fill="colors.WHITE" d="M31.31 50.575L44.246 50.575 44.246 40.639 31.31 40.639z" transform="translate(-227 -124) translate(227 124) translate(21.467 .111)"/>
                        <path :fill="colorsV2.LIGHT_200" d="M44.2 19.484H30.062c-.752 0-1.26-.742-.97-1.414l7.33-16.957c.263-.61 1.152-.61 1.416 0l7.33 16.957c.29.672-.218 1.414-.97 1.414" transform="translate(-227 -124) translate(227 124) translate(21.467 .111)"/>
                        <path :fill="colorsV2.LIGHT_400" d="M39.547 19.484h-4.18L37.006.892c.015-.174.274-.177.294-.005l2.246 18.597zM36.58 24.803h1.533v-2.3H36.58v2.3zm0 3.834h1.533v-2.3H36.58v2.3zm0 3.833h1.533v-2.3H36.58v2.3z" transform="translate(-227 -124) translate(227 124) translate(21.467 .111)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</template>

<script>
import consts from 'services/metaData/consts';
export default {
    name: 'noAppIcon',
    data() {
        return {
            colors: consts.COLORS,
            colorsV2: consts.COLORS_V2
        };
    },
    beforeMount() {
        this.$parent.$emit('size', '0 0 117 92');
    }
}
</script>
